import { Typography, Card } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { IDam } from '../../../@types/model/dam/dam';
import { IRootState } from '../../../@types/redux';
import { Transitions } from '../../customComponents/animations/Transitions';
import EditDamDivisionInfo from '../dialog/EditDivisionInfoDialog';

interface IDamDivisionProps {
    dam : IDam;

    isLoading : boolean;

    isDamAdmin : boolean;
}

interface IDamDivisionState {
}

class DamDivisionComponent extends React.PureComponent<IDamDivisionProps, IDamDivisionState> {
    constructor(props : IDamDivisionProps) {
        super(props);
        this.state = {
        };
    }

    public readonly render = () => {
        const { dam, isDamAdmin, isLoading } = this.props;
        return (
            <div className={'flx1 fdr aifs jcc mt15'}>
                <Card className={'bcw mt30 fdc'}>
                    <div className={'fdr flx1 dvbdg cw mb10 p10'}>
                        <Typography className={'fdr aic jcc flx1 fw600 fs16'}>
                            DIVISION INFORMATION
                        </Typography>
                        <div className='posr posr aic jcc'>
                            <div className='posa posr0'>
                                {
                                    isDamAdmin &&
                                    <EditDamDivisionInfo
                                        dam={dam}
                                        isLoading={isLoading}
                                        fullWidth
                                        maxWidth='md'
                                        transition={Transitions.Down}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div className={'fdc flx1 ml17 mr17 mb13'}>
                        <div className={'flx1 mt9 fdr'}>
                            <div className={'bcg0 fdc aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    DIVISION
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {dam.division ? dam.division : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    MANAGMENT AREA
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {dam.managementArea ? dam.managementArea : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    DIVISION NUMBER
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {dam.divisionNumber ? dam.divisionNumber : 'None'}
                                </Typography>
                            </div>
                            <div className={'bcg0 fdc aic jcc mr8 w200 p10'}>
                                <Typography className={'fs11 cdg'}>
                                    ACCPAC DESCRIPTION
                                </Typography>
                                <Typography className={'fs13 cg3 fw700 pt10'}>
                                    {dam.divisionDescriptionAccpac ? dam.divisionDescriptionAccpac : 'None'}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        isDamAdmin: !!state.auth.session?.employee.IsDamAdmin,
        isLoading: state.dam.loading,
    };
};

const DamDivisionView = connect(
    mapStateToProps,
)(DamDivisionComponent);

export default DamDivisionView;

